import React from 'react';
import t from '~t';
import { useSelector } from 'react-redux';
import { user } from '~data/selectors/user';
import { Helmet } from 'react-helmet';
import { Header } from '~co/screen/splitview/main';
import { HeaderTitle as Title } from '~ui'

import Free from './free';
import Paid from './paid';

export default function SettingsPro(props) {
  const currentUser = useSelector(user);
  const Component = currentUser.pro ? Paid : Free;

  return (
    <>
      <Helmet>
        <title>{t.s('subscription')}</title>
      </Helmet>
      <Header data-fancy>
        <Title>{t.s('subscription')}</Title>
      </Header>

      <Component {...props} />
    </>
  );
}
